import chunk from './chunk'

const batchPromises = function (collection, batchSize, singlePromise) {
  const chunks = chunk(collection, batchSize)

  const batchResult = []

  function chunkReducer (accumulator, chunk, index) {
    return accumulator.then(function () {
      return batchPromisesChunk(chunk, singlePromise)
        .then(function (chunkResult) {
          batchResult.splice(batchResult.length, 0, ...chunkResult)
          return chunkResult
        })
    }).catch(Promise.reject)
  }

  const initialValue = Promise.resolve([])

  return chunks.reduce(chunkReducer, initialValue).then(() => {
    return Promise.resolve(batchResult)
  })
}

function batchPromisesChunk (chunk, singlePromise) {
  const calls = chunk.map((chunkValue) => singlePromise(chunkValue))
  return Promise.all(calls)
}

export default batchPromises
